import * as z from 'zod';

export const callbackSearchSchema = z.object({
	e: z.union([z.string(), z.number()]).optional(),
	id_token: z.string().optional(),
});
